module.exports = __webpack_public_path__ + "img/AC.03031ea5.svg";